import i18n from 'translate';

export const LoginPageStrings = {
  createAccountButtonTitle: () => i18n.t('loginPage.createAccountButtonTitle'),
  loginTitle: () => i18n.t('loginPage.loginTitle'),
  privacyPolicyConfirmMessage: (linkColor: string) => i18n.t('loginPage.privacyPolicyConfirmMessage', { linkColor }),
  signUpTitle: () => i18n.t('loginPage.signUpTitle')
};
